import {useSelector} from "react-redux";
import {selectAllCities} from "../../../selectors";

export const useCities = () => {
  return useSelector(selectAllCities);
};